import { HostListener, Component } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Routes, RouterModule, Router } from '@angular/router';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../../common/global-constants';
import { customfunctions } from '../../common/customfunctions';
import { ProductionStaffModel } from "./prd-staff-model"
import * as Highcharts from 'highcharts'
import { ApiMethod } from '../../apimethods/api-method';
declare var $;

@Component({
  selector: 'app-prd-staff',
  templateUrl: './prd-staff.component.html',
  styleUrls: ['./prd-staff.component.css']
})
/** prd-staff component*/
export class PrdStaffComponent {
  modelItem = new ProductionStaffModel();
  today: any = new Date();
  yesterday: any = new Date();
  previousMonth: any = new Date();
  OverAllArticles: number;
  OverAllPages: number;
  OverAllBatch: string;
  TodayArticles: number;
  TodayPages: number;
  TodayBatch: string;
  YesterdayArticles: number;
  YesterdayPages: number;
  YesterdayBatch: string;
  CurrentMonthArticles: number;
  CurrentMonthPages: number;
  CurrentMonthBatchCount: string;
  PreviousMonthArticles: number;
  PreviousMonthPages: number;
  PreviousMonthBatchCount: string;
  CurrentYearArticles: number;
  CurrentYearPages: number;
  CurrentYearBatchCount: string;
  PendingArticles: number;
  PendingPages: number;
  ngOnInit(): void {
    customfunctions.SetDateValues('#Txt_FromDate', '#Txt_ToDate');

    this.yesterday.setDate(this.yesterday.getDate() - 1)
    this.previousMonth.setMonth(this.previousMonth.getMonth() - 1)
    ApiMethod.getBaseUrl();
  }
  constructor(private router: Router) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <ProductionStaffModel>data["DashboardPage"];

        this.GetDashboardDetails();

      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }



  GetDashboardDetails(): void {
    $("#LoadingImage").show();
    var postData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID
    };
    ApiMethod.postMethod(this.modelItem.ProductionDashboardSummaryAPI, postData).subscribe(
      resonse => {
        var items = resonse.aitemList
        if (items.length > 0) {
          for (let i = 0; i < items.length; i++) {
            try {
              if (items[i].Type == 'Today') {
                this.TodayArticles = items[i].ArticleCount == null ? 0 : items[i].ArticleCount;
                this.TodayPages = items[i].PagesCount == null ? 0 : items[i].PagesCount;

              }
              if (items[i].Type == 'Yesterday') {
                this.YesterdayArticles = items[i].ArticleCount == null ? 0 : items[i].ArticleCount;
                this.YesterdayPages = items[i].PagesCount == null ? 0 : items[i].PagesCount;

              }
              if (items[i].Type == 'CurrentMonth') {
                this.CurrentMonthArticles = items[i].ArticleCount == null ? 0 : items[i].ArticleCount;
                this.CurrentMonthPages = items[i].PagesCount == null ? 0 : items[i].PagesCount;

              }
              if (items[i].Type == 'PreviousMonth') {
                this.PreviousMonthArticles = items[i].ArticleCount == null ? 0 : items[i].ArticleCount;
                this.PreviousMonthPages = items[i].PagesCount == null ? 0 : items[i].PagesCount;

              }
              if (items[i].Type == 'Overall') {
                this.OverAllArticles = items[i].ArticleCount == null ? 0 : items[i].ArticleCount;
                this.OverAllPages = items[i].PagesCount == null ? 0 : items[i].PagesCount;

              }
              if (items[i].Type == 'Pending') {
                this.PendingArticles = items[i].ArticleCount == null ? 0 : items[i].ArticleCount;
                this.PendingPages = items[i].PagesCount == null ? 0 : items[i].PagesCount;

              }
            } catch (e) {
              console.log(e);
            }
          }
        }

        let SummaryList = resonse.aitemColList;

        let chartDataCol: any = []; let chartDataCol1: any = []; let monthList: any = [];
        $(SummaryList).each(function (index, val) {
          let _monthYear = val.CurrentMonth + '-' + val.CurrentYear;
          chartDataCol.push({ y: val.Ingestions, name: _monthYear });
          chartDataCol1.push({ y: val.Delivery, name: _monthYear });
          monthList.push(_monthYear);
        });

        this.LoadChartData(chartDataCol, chartDataCol1, monthList);
        $("#LoadingImage").hide();
      },
      error => {
        $("#LoadingImage").hide();
      }
    );

  }

  highchartsPie: typeof Highcharts = Highcharts; chartOptions;
  highchartsCol: typeof Highcharts = Highcharts; chartOptionsCol;

  LoadChartData(chartDataCol, chartDataCol1, monthList): void {
    try {

      //Column Chart
      this.highchartsCol = Highcharts;
      this.chartOptionsCol = {
        chart: {
          type: 'column',
          style: {
            fontFamily: 'Poppins, Arial, sans-serif'  // Specify a readable font family
          }
        },
        title: {
          text: 'Articles Count & Pages'
        },
        xAxis: {
          categories: monthList,
          crosshair: true,
        },
        yAxis: {
          min: 0,
          title: {
            text: ''
          }
        },
        tooltip: {
          headerFormat: '<span style = "font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style = "color:{series.color};padding:0">{series.name}: </td>' +
            '<td style = "padding:0"><b>{point.y}</b></td></tr>', footerFormat: '</table>', shared: true, useHTML: true
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        series: [
          {
            name: 'Articles Count',
            data: chartDataCol,
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          },
          {
            name: 'Pages',
            data: chartDataCol1,
            dataLabels: {
              enabled: true,
              color: '#000',
              format: '{point.y}'
            }
          }
        ],

      };
    } catch (e) {
      $("#LoadingImage").hide();
      ngswal(e);
    }
  }
}
